

import { useEffect, useState } from "react";



// @mui material components
import Card from "@mui/material/Card";
import CardContent from '@mui/material/CardContent';
import Grid from "@mui/material/Grid";


import Autocomplete from '@mui/material/Autocomplete';
import Dialog from '@mui/material/Dialog';
import MenuItem from '@mui/material/MenuItem';
import ReactHookFormSelect from "common/components/mycomponents/ReactHookFormSelect";


// Material Dashboard 2 React components
import MDBox from "common/components/MD/MDBox";
import MDButton from "common/components/MD/MDButton";
import MDInput from "common/components/MD/MDInput";
import MDTypography from "common/components/MD/MDTypography";



// Authentication layout components piu largo

// Images


//validazione lato client
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';

function InvitiEditModal({ onSave, onClose, show, tipo_dot, id_richiesta,num_max }) {

  const [invito, setInvito] = useState({
    idInvito: 0,
    id_richiesta: id_richiesta,
    nome: '',
    cognome: '',
    azienda: '',
    email: '', tipo_dot: '',num:''
  });

  let num_maxx=num_max>=5?5:num_max;

  /* ----------------------------FUNZIONALITA PAGINA------------------------------------------------- */


  /* ----------------------------CARICAMENTO E RIEMPIMENTO CAMPI------------------------------------------------- */


  useEffect(() => {
    if (show) {

setValue("azienda","");
setValue("cognome","");
setValue("nome","");
setValue("email","");
setValue("tipo_dot",tipo_dot);
setValue("id_richiesta",id_richiesta);





    }
  }, [show]);


  /* ----------------------------VALIDAZIONE E SALVATAGGIO----------------------------------------------------------------------- */

  const validationSchema = Yup.object().shape({

    email: Yup.string()
      .required('Email richiesta')
      .email('Email non valida'),
    cognome: Yup.string()
      .required('Cognome richiesto'),
    nome: Yup.string()
      .required('Nome richiesto'),
  });
  /* ----------------------------SALVATAGGIO E REGISTRAZIONE------------------------------------------------- */

  const {
    register, //register inputs
    reset, setValue, control,
    handleSubmit,//handle form submit
    formState: { errors }
  } = useForm({
    resolver: yupResolver(validationSchema)
  });



  /* ---------------- ALERT -------------------------------------------------------------------------------------------------------- */





  /* ------------------------------navigazione -----------------------------------------------------------------*/



  const handleKeyDown = (e) => {
    const { key, target } = e

    if (key !== "Enter" || target instanceof HTMLTextAreaElement) {
      return
    }

    e.preventDefault()
  }

  return (
    <Dialog open={show} onClose={onClose}>

      <MDBox pt={3} pb={3}>


        <Grid container spacing={6}>

          <Grid item xs={12}>
            <Card >

              <MDBox pt={1} pb={3} px={3} component="form" role="form" onKeyDown={handleKeyDown}>


                <CardContent>
                  <MDBox>
                    <MDBox mb={2}>

                      <MDButton variant="gradient" color="success" fullWidth>
                        <MDTypography variant="h5" fontWeight="regular" sx={{
                          color: "#FFFFFF"
                        }}>Aggiungi alla tua lista di invio</MDTypography>
                      </MDButton>
                    </MDBox>
                    <MDBox mb={2} ><MDTypography variant="button">I campi con * sono obbligatori</MDTypography></MDBox>
                   
                   <MDBox>       <MDInput type="hidden"  label="id_richiesta" name='id_richiesta'  {...register('id_richiesta')}  /></MDBox>
                    <MDBox mb={2} >
                      <MDBox>
                        <MDInput type="text" label="Azienda" name='azienda' fullWidth  {...register('azienda')}
                          InputLabelProps={{ shrink: true }}
                        />
                      </MDBox>
                    </MDBox>

                  </MDBox>
                    
                   
                  <MDBox mb={2} sx={{ display: 'grid', gap: 1, gridTemplateColumns: '1fr 1fr' }}>
                    <MDBox >
                      <MDInput type="text" fullWidth label="Cognome" required name='cognome'  {...register('cognome')} error={errors.cognome ? true : false} InputLabelProps={{ shrink: true }} />
                      {errors.cognome ? <span style={{ color: 'red', fontSize: '12px' }}>{errors.cognome?.message}</span> : ''}
                    </MDBox>
                    <MDBox>
                      <MDInput type="text" fullWidth label="nome" required name='nome'  {...register('nome')} error={errors.nome ? true : false} InputLabelProps={{ shrink: true }} />
                      {errors.nome ? <span style={{ color: 'red', fontSize: '12px' }}>{errors.nome?.message}</span> : ''}
                    </MDBox>

                  </MDBox>




                  <MDBox mb={2} sx={{ display: 'grid', gap: 1, gridTemplateColumns: '1fr' }}>

                    <MDBox mb={2} >
                      <MDInput type="text" label="Email" fullWidth required name='email' {...register('email')} error={errors.email ? true : false} InputLabelProps={{ shrink: true }} />
                      {errors.email ? <span style={{ color: 'red', fontSize: '12px' }}>{errors.email?.message}</span> : ''}
                    </MDBox>
                  </MDBox>


                  <MDBox mb={2}>
                    <ReactHookFormSelect
                      id="tipo_dot"
                      name="tipo_dot"
                      label="Tipo Invito"
                      control={control}
                      defaultValue={tipo_dot}
                      variant="outlined"
                      required
                      disabled={true}
                      error={errors.tipo_dot ? true : false}
                    >
                      <MenuItem
                        key='IR'
                        value='IR'
                      >
                        RIDOTTO
                      </MenuItem>

                      <MenuItem
                        key='IO'
                        value='IO'
                      >
                        OMAGGIO
                      </MenuItem>
<MenuItem
                        key='PE'
                        value='PE'
                      >
                       PASS ESPOSITORE
                      </MenuItem>
                    </ReactHookFormSelect>
                    {errors.tipo_dot ? <span style={{ color: 'red', fontSize: '12px' }}>{errors.tipo_dot?.message}</span> : ''}
                  </MDBox>

                 <MDBox mb={2}>
                    <ReactHookFormSelect
                      id="num"
                      name="num"
                      label="Quantità inviti "
                      control={control}
                      defaultValue={1}
                      variant="outlined"
                      required
                     
                    >
           {Array.from({ length: num_maxx }, (_, i) => (
    <MenuItem key={i + 1} value={i + 1}>
      {i + 1}
    </MenuItem>
  ))}
 

                    </ReactHookFormSelect>
               </MDBox>



                  <MDBox sx={{ display: 'flex', flexDirection: 'row', pt: 2 }} mt={4} mb={1}>
                    <MDButton variant="outlined" color="success" onClick={onClose}   >
                      Annulla le modifiche
                    </MDButton>
                    <MDBox sx={{ flex: '1 1 auto' }} />
                    <MDBox ml={2}>

                    </MDBox>
                    <MDBox ml={2}>
                      <MDButton variant="gradient" color="success" onClick={handleSubmit(onSave)} type="submit"   >
                        Salva
                      </MDButton>
                    </MDBox>

                  </MDBox>



                </CardContent>

              </MDBox>

            </Card>
          </Grid >
        </Grid >
      </MDBox >

    </Dialog>
  );
}

export default InvitiEditModal;
